module.exports = __webpack_public_path__ + "static/surgery.5fe54a34.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/surgery.png
// module id = 451
// module chunks = 168707334958949